import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import { VueAxios } from "./utils/request";
import VueStorage from "vue-ls";

Vue.config.productionTip = false;

Vue.use(mavonEditor);
Vue.use(VueAxios);
Vue.use(VueStorage);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
